export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5367.c9a49c60.jpg";